const ITEMS = ["Website Design", "Development", "Hosting", "Launch", "Security", "Maintenance", "Updates", "Support"];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative border-y border-slate-200 bg-[#FAFAFA] py-7 overflow-hidden" aria-hidden="true" data-testid="editorial-marquee">
      <div className="marquee-track flex whitespace-nowrap will-change-transform">
        {row.map((t, i) => (
          <span key={i} className="flex items-center shrink-0">
            <span className="font-display text-2xl sm:text-4xl font-semibold tracking-tight uppercase px-8 text-transparent" style={{ WebkitTextStroke: "1px rgba(15,23,42,0.2)" }}>
              {t}
            </span>
            <span className="w-2 h-2 rounded-full bg-[#0055FF]" />
          </span>
        ))}
      </div>
    </div>
  );
};
